import * as React from "react"
const Crowdfunding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M16 3C10.486 3 6 7.486 6 13s4.486 10 10 10 10-4.486 10-10S21.514 3 16 3Zm0 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8Zm-1 2v1.19a3.076 3.076 0 0 0-1.674 1.464 2.918 2.918 0 0 0-.264 1.945c.123.574.408 1.1.822 1.516.273.273.598.494.956.647.358.153.75.238 1.16.238.142 0 .276.027.396.076a.96.96 0 0 1 .528.528c.049.12.076.254.076.396a.976.976 0 0 1-.604.924c-.12.049-.254.076-.396.076-.143 0-.276-.027-.396-.076a.96.96 0 0 1-.532-.539A.995.995 0 0 1 15 15h-2c0 .778.308 1.524.857 2.076.321.328.712.579 1.143.735V19h2v-1.19a3.024 3.024 0 0 0 1.96-2.335 2.944 2.944 0 0 0-.478-2.145 3.027 3.027 0 0 0-1.882-1.268A2.936 2.936 0 0 0 16 12c-.143 0-.276-.027-.396-.076a.96.96 0 0 1-.528-.528A1.045 1.045 0 0 1 15 11c0-.143.027-.276.076-.396a.96.96 0 0 1 .528-.528c.12-.049.254-.076.396-.076.57 0 1 .43 1 1h2c0-.314-.05-.626-.148-.924A3.045 3.045 0 0 0 17 8.19V7h-2ZM2 21v8h2v-6h5.38a12.093 12.093 0 0 1-2.3-2H2Zm22.92 0a12.093 12.093 0 0 1-2.3 2H28v6h2v-8h-5.08ZM6 25v2h20v-2H6Z"
    />
  </svg>
)
export default Crowdfunding